@if (loadedError) {
  <app-widgets-overlay [type]="loadedErrorReason"></app-widgets-overlay>
}
@if (!loadedError && loaded && !data) {
  <app-widgets-overlay type="no-match"></app-widgets-overlay>
}
@if (loaded) {
  <div class="widget-container d-flex flex-column">
    <div class="widget-container__object">
      @if (!noTitle) {
        <h1 class="widget-title align-self-center">
          {{ 'web.widget_double_chance_last10games' | translate }}
        </h1>
      }
      <div class="d-flex">
        @if (data?.home; as p) {
          <div class="widget-team mt-1 d-flex flex-column" data-cy="team">
            <div class="widget-team__name d-flex align-items-center">
              <img
                (error)="imageError($event)"
                [attr.src]="p.image | responsive : 'participant' : 'medium'"
                [alt]="p.name"
                class="img-fluid app-cursor mr-1"
                />
              <div>{{ p.name }}</div>
            </div>
          </div>
        }
        @if (data?.away; as p) {
          <div
            class="widget-team mt-1 d-flex flex-column widget-team--second"
            data-cy="team"
            >
            <div class="widget-team__name d-flex align-items-center justify-content-end">
              <div>{{ p.name }}</div>
              <img
                (error)="imageError($event)"
                [attr.src]="p.image | responsive : 'participant' : 'medium'"
                [alt]="p.name"
                class="img-fluid app-cursor ml-1"
                />
            </div>
          </div>
        }
      </div>
      <!-- Double chance -->
      <div class="d-flex flex-column widget-form-participant-container">
        <div class="d-flex justify-content-between">
          <div class="widget-form-participant widget-form-participant--home" data-cy="cornersHome">
            &nbsp;
          </div>
          <div class="widget-form-participant-text font-weight-bold font-1-1x">
            {{ 'web.participant_win_or_draw_prct' | translate }}
          </div>
          <div class="widget-form-participant widget-form-participant--away" data-cy="cornersAway">
            &nbsp;
          </div>
        </div>
        <div class="d-flex justify-content-around">
          <app-chart-circle-somple [percentage]="home" [text]="data?.home?.name">
            {{ home }}%
          </app-chart-circle-somple>
          <app-chart-circle-somple [percentage]="away" [text]="data?.away?.name">
            {{ away }}%
          </app-chart-circle-somple>
        </div>
      </div>
      <div class="d-flex flex-column widget-form-participant-container">
        <div class="d-flex justify-content-between">
          <div class="widget-form-participant widget-form-participant--home" data-cy="streakHome">
            {{ home1 }}%
          </div>
          <div class="widget-form-participant-text align-self-end">
            {{ 'web.participant_win_or_draw_1period_' + sportName + '_prct' | translate }}
          </div>
          <div class="widget-form-participant widget-form-participant--away" data-cy="streakAway">
            {{ away1 }}%
          </div>
        </div>
        <div class="d-flex">
          <div
            class="widget-form-participant-bar widget-form-participant-bar--home"
            [style.width.%]="homeWidth1"
            >
            {{ data?.home?.name }}
          </div>
          <div
            class="widget-form-participant-bar widget-form-participant-bar--away"
            [style.width.%]="awayWidth1"
            >
            {{ data?.away?.name }}
          </div>
        </div>
      </div>
      <div class="d-flex flex-column widget-form-participant-container">
        <div class="d-flex justify-content-between">
          <div class="widget-form-participant widget-form-participant--home" data-cy="streakHome">
            {{ home2 }}%
          </div>
          <div class="widget-form-participant-text align-self-end">
            {{ 'web.participant_win_or_draw_2period_' + sportName + '_prct' | translate }}
          </div>
          <div class="widget-form-participant widget-form-participant--away" data-cy="streakAway">
            {{ away2 }}%
          </div>
        </div>
        <div class="d-flex">
          <div
            class="widget-form-participant-bar widget-form-participant-bar--home"
            [style.width.%]="homeWidth2"
            >
            {{ data?.home?.name }}
          </div>
          <div
            class="widget-form-participant-bar widget-form-participant-bar--away"
            [style.width.%]="awayWidth2"
            >
            {{ data?.away?.name }}
          </div>
        </div>
      </div>
      @if (hasPeriod3) {
        <div class="d-flex flex-column widget-form-participant-container">
          <div class="d-flex justify-content-between">
            <div class="widget-form-participant widget-form-participant--home" data-cy="streakHome">
              {{ home3 }}%
            </div>
            <div class="widget-form-participant-text align-self-end">
              {{ 'web.participant_win_or_draw_3period_' + sportName + '_prct' | translate }}
            </div>
            <div class="widget-form-participant widget-form-participant--away" data-cy="streakAway">
              {{ away3 }}%
            </div>
          </div>
          <div class="d-flex">
            <div
              class="widget-form-participant-bar widget-form-participant-bar--home"
              [style.width.%]="homeWidth3"
              >
              {{ data?.home?.name }}
            </div>
            <div
              class="widget-form-participant-bar widget-form-participant-bar--away"
              [style.width.%]="awayWidth3"
              >
              {{ data?.away?.name }}
            </div>
          </div>
        </div>
      }
      <div class="w-100 text-center widget-form-participant-text app-word-nowrap">
        {{ 'web.num_of_matches' | translate }} ({{ num }})
      </div>
      <div class="widget-logo d-flex justify-content-center mt-4">
        <img
          [src]="'/img/' + client.getName() + '.png'"
          [alt]="client.getName()"
          data-cy="logo"
          class="widget-logo-client"
          />
      </div>
    </div>
  </div>
}
